import React from "react";
import SpecialDaysCreateEditTemplate from "../../../../components/templates/specialDays/specialDaysCreateEditTemplate";
import {useStores} from "../../../../stores/useStores";
import {useParams} from "react-router";
import {ToastMessageStatus} from "../../../../components/atoms/toastMessage/toastMessage";
import {useTranslation} from "react-i18next";
import Occasion from "../../../../stores/domainStore/pages/models/occasion";

type EditSpecialDayParams = {
  id: string;
};

// Testing this file means mocking almost everything, it's integration testing, not unit testing
/* istanbul ignore file */
const EditSpecialDay: React.FC = () => {
  const {
    uiStore: {toastMessageStore},
    domainStore: {occasionDomainStore}
  } = useStores();
  const {t} = useTranslation(["specialDays"]);
  let {id} = useParams<EditSpecialDayParams>();

  const updateSpecialDayAsync = async (payload: Occasion) => {
    try {
      await occasionDomainStore.updateOccasion(id, payload);
      toastMessageStore.displayToastMessage(
        t("specialDays:messages.updatedSpecialDay", {
          occasionTitle: payload.title.text
        }),
        ToastMessageStatus.Success
      );
    } catch {
      toastMessageStore.displayToastMessage(
        t("specialDays:messages.updatedSpecialDayFailure", {
          occasionTitle: payload.title.text
        }),
        ToastMessageStatus.Danger
      );
      throw new Error();
    }
  };

  const deleteSpecialDayAsync = async (
    specialDayId: string,
    specialDayTitle: string
  ) => {
    try {
      await occasionDomainStore.deleteOccasion(specialDayId);
      toastMessageStore.displayToastMessage(
        t("specialDays:messages.deletedSpecialDay", {
          occasionTitle: specialDayTitle
        }),
        ToastMessageStatus.Success
      );
    } catch {
      toastMessageStore.displayToastMessage(
        t("specialDays:messages.deletedSpecialDayFailure", {
          occasionTitle: specialDayTitle
        }),
        ToastMessageStatus.Danger
      );
      throw new Error();
    }
  };

  return (
    <SpecialDaysCreateEditTemplate
      specialDayId={id}
      onPublish={updateSpecialDayAsync}
      deleteSpecialDay={deleteSpecialDayAsync}
    />
  );
};

export default EditSpecialDay;
